/**
 * Method that will collect the tracking information from the URL
 */
export default () => {
    try {
        /**
         * Collect the parameters that we need
         */
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);

        /**
         * The length for the cookies
         */
        const days = 30;

        /**
         * Parameters that we will search for and collect
         */
        const parameters = {
            "ui": "tracking_id",
            "utm_id": "tracking_utm_id",
            "utm_source": "tracking_utm_source",
            "utm_medium": "tracking_utm_medium",
            "utm_campaign": "tracking_utm_campaign",
            "utm_term": "tracking_utm_term",
            "utm_content": "tracking_utm_content",
            "gclid": "tracking_gclid",
        }

        /**
         * Iterate the parameters and search for them in the URL
         */
        Object.keys(parameters).forEach((key) => {
            let property = parameters[key];

            /**
             * Verify that we have a parameter
             */
            if (urlParams.has(key)) {
                createCookie(property, urlParams.get(key), days, '/', true);
            }
        });
    } catch (error) {

    }
}
